import FieldType from '@/shared/components/forms/WaveUIForm_V2/types/fieldType.enum';
import FormField from '@/shared/components/forms/WaveUIForm_V2/types/formField.type';
import transformMetadataForm from '@/shared/hooks/useMetadataForm/utils/transformMetadataForm';

const getMetadataTransformedForm = (details: FormField[][]) => {
  return transformMetadataForm(
    details
      .flat()
      .filter((item) => item.isVisible)
      .map((item) => {
        if (item.field_type === FieldType.Switch) {
          return {
            name: item.field_props.name,
            checked: item.field_props.checked,
          };
        }

        return {
          name: item.field_props.name,
          value: item.field_props.value,
        };
      })
      .reduce((acc, curr) => {
        return {
          ...acc,
          [curr.name]:
            typeof curr.checked === 'undefined' ? curr.value : curr.checked,
        };
      }, {}),
  );
};

export default getMetadataTransformedForm;
